import { creatorLightTheme } from '@spotify-internal/encore-web';
import { getModuleBackgroundColor as getModuleBackgroundColorGlobal } from './getModuleColors';
export const getModuleBackgroundColor = (mod, activeSlideMap) => {
    var _a, _b;
    const activeMod = ((_a = mod.carouselSlides) === null || _a === void 0 ? void 0 : _a.length) &&
        ((_b = mod.carouselSlides) === null || _b === void 0 ? void 0 : _b.length) > 0 &&
        activeSlideMap
        ? activeSlideMap.get(mod.id || '') || mod
        : mod;
    return getModuleBackgroundColorGlobal(activeMod);
};
export const getInitialActiveSlideMap = (allModules) => {
    const initialActiveSlides = allModules === null || allModules === void 0 ? void 0 : allModules.filter((mod) => {
        var _a, _b;
        return mod.id &&
            mod.contentType !== 'singleFeatureModule' &&
            ((_a = mod === null || mod === void 0 ? void 0 : mod.carouselSlides) === null || _a === void 0 ? void 0 : _a.length) &&
            ((_b = mod === null || mod === void 0 ? void 0 : mod.carouselSlides) === null || _b === void 0 ? void 0 : _b.length) > 0;
    }).map((mod) => {
        var _a;
        const firstSlide = mod.contentType === 'heroNarrativeCarousel'
            ? mod
            : (_a = mod === null || mod === void 0 ? void 0 : mod.carouselSlides) === null || _a === void 0 ? void 0 : _a[0];
        return mod.id && firstSlide ? [mod.id, firstSlide] : null;
    }).filter(slideMap => (slideMap === null || slideMap === void 0 ? void 0 : slideMap[0]) && (slideMap === null || slideMap === void 0 ? void 0 : slideMap[1]));
    return (initialActiveSlides === null || initialActiveSlides === void 0 ? void 0 : initialActiveSlides.length) && initialActiveSlides.length > 0
        ? new Map(initialActiveSlides)
        : undefined;
};
export const getGraphicTransitionModuleColors = (modules, graphicTranistionIndex, activeSlideMap) => {
    const moduleAbove = modules[graphicTranistionIndex - 1];
    const moduleBelow = modules[graphicTranistionIndex + 1];
    return {
        topColor: moduleAbove
            ? getModuleBackgroundColor(moduleAbove, activeSlideMap)
            : creatorLightTheme.invertedDark.background.base,
        bottomColor: moduleBelow
            ? getModuleBackgroundColor(moduleBelow, activeSlideMap)
            : creatorLightTheme.invertedDark.background.base,
    };
};
